  const loginUrl = {
    development: 'https://signinsit.midea.com/login',
    SIT: 'https://signinuat.midea.com/login',
    UAT: 'https://signinuat.midea.com/login',
    PROD: 'https://signin.midea.com/login',
  };
  const logoutUrl = {
    development: 'https://signinsit.midea.com/logout',
    SIT: 'https://signinuat.midea.com/logout',
    UAT: 'https://signinuat.midea.com/logout',
    PROD: 'https://signin.midea.com/logout',
  };
  const gsrmUrl = {
    development: 'https://erpu2ex.midea.com:5555/OA_HTML/OA.jsp?OAFunc=OAHOMEPAGE',
    SIT: 'http://srmsit.midea.com:8008/OA_HTML/OA.jsp?OAFunc=OAHOMEPAGE',
    UAT: 'https://erpu2ex.midea.com:5555/OA_HTML/OA.jsp?OAFunc=OAHOMEPAGE',
    PROD: 'https://srmext.midea.com:5555/OA_HTML/OA.jsp?OAFunc=OAHOMEPAGE'
  };
  const forgetPasswordUrl = {
    development: 'https://aquat.midea.com/f/find/',
    SIT: 'https://aquat.midea.com/f/find/',
    UAT: 'https://aquat.midea.com/f/find/',
    PROD: 'https://aq.midea.com/f/find/'
  };
  export default {
    loginUrl: loginUrl[process.env.VUE_APP_ENV || 'development'],
    logoutUrl: logoutUrl[process.env.VUE_APP_ENV || 'development'],
    gsrmUrl: gsrmUrl[process.env.VUE_APP_ENV || 'development'],
    forgetPasswordUrl: forgetPasswordUrl[process.env.VUE_APP_ENV || 'development']
  };